import { Toast } from "../../toast";
import type { ToastProviderViewProps } from "./types-provider";

/** Os filhos e UM `Toast` do Prime; as cores vêm do tema (D32). */
export function ToastProviderView({
  toastRef,
  position,
  className,
  style,
  rest,
  children,
}: ToastProviderViewProps) {
  return (
    <>
      {children}
      <Toast ref={toastRef} {...rest} position={position} className={className} style={style} />
    </>
  );
}
